<template>
  <div class="box pt-0">
    <FileNode :node="tree" v-on:select_file="onFileSelected" />
  </div>
</template>

<script>
import FileNode from "./FileNode.vue";

export default {
  name: "FileTree",
  props: {
    tree: {
      type: Object,
      required: true,
    },
  },
  components: {
    FileNode,
  },
  methods: {
    onFileSelected(file) {
      this.$emit("file_selected", file);
    },
  },
};
</script>
